<div class="row" style="height: 100%">
  <div class="col-xl-2 col-lg-1 d-none d-lg-block"></div>
  <div class="col-xl-4 col-lg-6 col-12">
    <div id="root-container" class="h-100">
      <router-outlet></router-outlet>
      <ngx-spinner
        type="ball-scale-multiple"
        [color]="spinnerColor"
        [fullScreen]="true"></ngx-spinner>
    </div>
    <div class="fastmenu-link text-center mt-2">
      <a
        href="https://kithoreca.hipermercode.com/"
        target="_blank"
        class="text-decoration-none"
        >kithoreca.hipermercode.com</a
      >
    </div>
  </div>
  <div class="col-xl-3 col-lg-5 d-none d-lg-block">
    @if (restaurant) {
      <div class="container">
        <h1 style="margin-top: 40%">{{ restaurant.title }}</h1>
        <div style="margin-top: 1rem">
          @if (restaurant.timeOpen) {
            <div class="schedule text-muted">
              {{ 'SCHEDULE' | translate }}: {{ restaurant.timeOpen }}
            </div>
          }
          @if (restaurant.phone) {
            <div class="phone mt-1 text-muted">
              {{ 'PHONE' | translate }}: {{ restaurant.phone }}
            </div>
          }
          <div class="delivery-method mt-3 text-muted">
            <label>{{ 'DISPOSAL' | translate }}:</label>
            <ul style="list-style: none">
              <li>
                <i class="fa fa-check" aria-hidden="true"></i>&nbsp;{{
                  'DIGITAL_CHART' | translate
                }}
              </li>
              @if (restaurant.isLocal) {
                <li>
                  <i class="fa fa-check" aria-hidden="true"></i>&nbsp;{{
                    'IS_LOCAL' | translate
                  }}
                </li>
              }
              @if (restaurant.isAutoservice) {
                <li>
                  <i class="fa fa-check" aria-hidden="true"></i>&nbsp;{{
                    'AUTOSERVICE' | translate
                  }}
                </li>
              }
              @if (restaurant.isTakeAway) {
                <li>
                  <i class="fa fa-check" aria-hidden="true"></i>&nbsp;{{
                    'TO_PICK_UP' | translate
                  }}
                </li>
              }
              @if (restaurant.isDelivery) {
                <li>
                  <i class="fa fa-check" aria-hidden="true"></i>&nbsp;{{
                    'DELIVERY' | translate
                  }}
                </li>
              }
              @if (restaurant.isTotem) {
                <li>
                  <i class="fa fa-check" aria-hidden="true"></i>&nbsp;{{
                    'IS_TOTEM' | translate
                  }}
                </li>
              }
            </ul>
            <label class="mt-3">{{ 'PAYMENT_METHOD2' | translate }}:</label>
            <ul style="list-style: none">
              @if (restaurant.isCashPaymentLocal) {
                <li>
                  <i class="fa fa-check" aria-hidden="true"></i>&nbsp;{{
                    'PAYMENT_3' | translate
                  }}
                </li>
              }
              @if (restaurant.isCardPaymentLocal) {
                <li>
                  <i class="fa fa-check" aria-hidden="true"></i>&nbsp;{{
                    'PAYMENT_2' | translate
                  }}
                </li>
              }
              @if (restaurant.isCardPaymentOnline) {
                <li>
                  <i class="fa fa-check" aria-hidden="true"></i>&nbsp;{{
                    'PAYMENT_1' | translate
                  }}
                </li>
              }
            </ul>
          </div>
          <p
            class="text-muted mt-3"
            style="font-size: 16px; overflow-y: auto; max-height: 260px">
            {{ restaurant.description }}
          </p>
          <div class="mt-3 text-end">
            <a
              href="https://www.google.com/maps/search/?api=1&query={{
                restaurant.latitude
              }},{{ restaurant.longitude }}"
              target="_blank"
              class="text-decoration-none"
              >{{ 'OPEN_GOOGLE_MAPS' | translate }}
            </a>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="col-xl-3 d-none d-xl-block">
    @if (restaurant) {
      <div class="container text-center">
        <div
          class="mt-5 mb-2 mx-auto"
          style="width: 160px; height: 160px; border: 1px solid #d8d8e3">
          <img id="qr" src="" style="max-width: 100%; height: 100%" />
        </div>
        <div class="text-muted py-2">
          {{ 'SCAN_PHONE' | translate }}
        </div>
        <a href="javascript:void(0)" (click)="downloadQr()">{{
          'DOWNLOAD' | translate
        }}</a>
        @if (
          restaurant?.urlFacebook || restaurant?.urlTwitter || restaurant?.urlInstagram
        ) {
          <div class="text-center social-btn-icons" style="display: block">
            @if (restaurant?.urlFacebook) {
              <a
                [href]="restaurant?.urlFacebook"
                target="_blank"
                class="fa-brands fa-facebook-f"></a>
            }
            @if (restaurant?.urlTwitter) {
              <a
                [href]="restaurant?.urlTwitter"
                target="_blank"
                class="fa-brands fa-twitter"></a>
            }
            @if (restaurant?.urlInstagram) {
              <a
                [href]="restaurant?.urlInstagram"
                target="_blank"
                class="fa-brands fa-instagram"></a>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
